import React, {ReactNode, useEffect, useRef, useState} from "react";
import './Photos.scss'
import styles from './Photos.module.scss'
import RoundIcon from "@/Atoms/RoundIcon";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import {Media} from "@/types/Media";
import {downloadFile} from "@/helpers/downloadFile";

export default function Photos(
  {
    images,
    zoom: initZoom,
    onDownload
  }: {
    images: (Media|string|File)[],
    zoom?: boolean,
    onDownload?: (image: string, index: number) => void
  }) {

  const [zoom, setZoom] = useState<boolean>(initZoom || false)
  const container = useRef(null);
  // prevent body from scrolling
  useEffect(() => {
    document.body.classList.toggle('unscrollable', zoom)
  }, [zoom]);


  const options = {
    showArrows: true,
    emulateTouch: true,
    useKeyboardArrows: true,
    swipeable: true,
    showStatus: false,
    dynamicHeight: false,
    showIndicators: false,
    infiniteLoop: true,
  };
  const handleClickItem = (index: number, item: ReactNode) => {

    setZoom(true)
  }


  const [selectedItem, setSelectedItem] = useState(0)
  useEffect(() => {

    const photoContainer = container.current ? container.current as HTMLDivElement : null
    const photoElements = photoContainer?.querySelectorAll<HTMLImageElement>('.photo');
    photoElements?.forEach((photoElement) => {
      const photoIndex: number = Number(photoElement.dataset.photoId)

      const image = images[photoIndex];
      if (image instanceof File){

        const reader = new FileReader();
        reader.onload = function (e) {
          // @ts-ignore
          photoElement.setAttribute('src', reader.result)
        }
        reader.readAsDataURL(image);
        return;
      }
    })

  }, [images.length]);

  const renderImages = (image: Media|string|File , index: number) => {

      const src = typeof image === 'string' ? image : (image && 'url' in image) ? image.url : undefined;
      return <div key={index} className={styles.slide}>
        <img src={src} alt={''} data-photo-id={index} className={`photo photo-${index}`} />
      </div>
  }

  return (
    <div className={'wrapper'} ref={container}>
      <div className={'photos'}>
        <Carousel
          {...options}
          className={styles.carousel}
          onChange={(index) => setSelectedItem(index)}
          selectedItem={selectedItem}
          showThumbs={images.length > 1}
          onClickItem={handleClickItem}
        >
          {images.map(renderImages)}
        </Carousel>
      </div>

      {zoom && (
      <div className={styles.fullscreen}>
        <div className={styles.tools}>
          {onDownload && <RoundIcon
            className={styles.close}
            icon={<i className="fa-solid fa-download"></i>}
            onClick={() => onDownload(images[selectedItem] as string, selectedItem)}
          />}

        <RoundIcon
          className={styles.close}
          icon={<i className="fa-solid fa-xmark"></i>}
          onClick={() => setZoom(false)}
        />
        </div>
        <Carousel
          {...options}
          showThumbs={false}
          // showStatus={true}
          className={styles.carousel}
          onChange={(index) => setSelectedItem(index)}
          selectedItem={selectedItem}
          onClickItem={() => setZoom(false)}
        >
          {images.map(renderImages)}

        </Carousel>
      </div>
        )}

    </div>


  );
}
